import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Linear = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      id="linear_group"
      fill="hsl(from hsl(234 57% 60%) h s 50%)"
      d="M0.9,14.7c-0.1-0.2,0.2-0.3,0.4-0.2l8.2,8.2c0.2,0.2,0,0.4-0.2,0.4C5.2,22.1,1.9,18.8,0.9,14.7z
	 M0.7,11.4c0,0.1,0,0.1,0.1,0.2l11.7,11.7c0,0,0.1,0.1,0.2,0.1c0.5,0,1.1-0.1,1.6-0.2c0.2,0,0.2-0.2,0.1-0.4L1.3,9.7
	C1.1,9.6,0.9,9.6,0.9,9.8C0.8,10.3,0.7,10.8,0.7,11.4z M1.6,7.5c0,0.1,0,0.2,0,0.2l14.6,14.6c0.1,0.1,0.2,0.1,0.2,0
	c0.4-0.2,0.8-0.4,1.2-0.6c0.1-0.1,0.1-0.2,0-0.3L2.6,6.3c-0.1-0.1-0.3-0.1-0.3,0C2,6.7,1.8,7.1,1.6,7.5z M3.5,4.9
	c-0.1-0.1-0.1-0.2,0-0.3c2.1-2.3,5.1-3.8,8.4-3.8c6.2,0,11.3,5,11.3,11.3c0,3.3-1.5,6.3-3.8,8.4c-0.1,0.1-0.2,0.1-0.3,0L3.5,4.9z"
    />
  </svg>
);
